export default __webpack_public_path__ + "static/session-dark-a75092234d282cbb0e91df30e103aec5.png";